import axios from 'axios';
import { API_ROOT } from 'config/api-config';
import { API_SERVER } from 'config/api-config';
import { TOKEN_ROOT } from 'config/api-config';
import { APP_CONTEXT } from 'config/api-config';
import { ALERT_ROOT } from 'config/api-config';
import { USE_PROXY } from 'config/api-config';
import moment from 'moment';
import { safeDecodeBase64 } from 'containers/common/innovel_util';

// Note: encryptedString functions removed - Express proxy handles authentication
// REACT_APP_SECRET is no longer exposed to client-side code

export function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

const clientRaw = window._env_?.REACT_APP_CLIENT_ID;

const clientId = safeDecodeBase64(clientRaw, process.env.REACT_APP_CLIENT_ID);

const current = moment.utc().format();
const date = moment.utc().format('x');

const PREFIX_LOGIN = 'Bearer ';

const httpClient = axios.create();

axios.defaults.timeout = 60000;

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
    //   if (error.response.status === 401) {
    //     // uses windows sessionStorage
    //     localStorage.removeItem('token');
    //     window.location.href = APP_CONTEXT + '/login';
    //   } else if (error.response.status === 403) {
    //     localStorage.removeItem('token');
    //     window.location.href = APP_CONTEXT + '/unauth';
    //   }
    }
    return Promise.reject(error);
  }
);

class ApiRepo {
  serviceCall = (httpMethod, path, inputParams, header) => {
    let url = '';

    if (path === '/oauth/token' || path === '/oauth/revoke-token') {
      url = TOKEN_ROOT + path;
      // url = "http://localhost:8085/innovel-services/rft/api/oauth/token";
      //           url = "http://localhost:8085/innovel-services/rft/api/oauth/token";
    } else {
      url = API_ROOT + path;
    }

    // setting access token
    let headerToSet;
    if (header === undefined) {
      if (localStorage.getItem('token') !== null) {
        headerToSet = {
          headers: {
            Authorization: PREFIX_LOGIN + localStorage.getItem('token'),
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            'client-Id' : clientId,
            'trace-id': uuidv4()
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      } else {
        headerToSet = {
          headers: {
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            'client-Id': clientId,
            'trace-id': uuidv4()
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      }
    } else {
      if (localStorage.getItem('token') !== null) {
        headerToSet = {
          headers: {
            ...header,
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            Authorization: PREFIX_LOGIN + localStorage.getItem('token'),
            'client-Id' : clientId
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      } else {
        headerToSet = {
          headers: {
            ...header,
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            'client-Id' : clientId
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      }
    }

    switch (httpMethod) {
      case 'get':
        return axios.get(url, headerToSet);
      case 'post':
        return axios.post(url, inputParams, headerToSet);
      case 'put':
        return axios.put(url, inputParams, headerToSet);
      case 'delete':
        return axios.delete(url, headerToSet);
      default:
        throw new Error('Unsupported http method');
    }
  };

  maintenanceServiceCall = (httpMethod, path, inputParams, header) => {
    let url = ALERT_ROOT + path;
    switch (httpMethod) {
      case 'get':
        return axios.get(url);
      default:
        throw new Error('Unsupported http method');
    }
  };

  //Testing
  utcTimeServiceCall = (httpMethod, path) => {
    let url = ALERT_ROOT + path;

    switch (httpMethod) {
      case 'get':
        return axios.get(url);
      default:
        throw new Error('Unsupported http method');
    }
  }
  //End Testing

  serviceCallV2 = (httpMethod, path, context, inputParams, header) => {
    var contextPath = '';
    switch (context) {
      case 'track':
        contextPath = '';
        break;
      default:
        contextPath = '';
        break;
    }

    let url = '';
    url = API_SERVER + contextPath + path;

    let headerToSet;
    if (header === undefined) {
      if (localStorage.getItem('token') !== null) {
        headerToSet = {
          headers: {
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            Authorization: PREFIX_LOGIN + localStorage.getItem('token')
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      } else {
        headerToSet = {
          headers: {
            'innovel-beta': 'true',
            'innovel-question-beta': 'true'
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      }
    } else {
      if (localStorage.getItem('token') !== null) {
        headerToSet = {
          headers: {
            ...header,
            'innovel-beta': 'true',
            'innovel-question-beta': 'true',
            Authorization: PREFIX_LOGIN + localStorage.getItem('token')
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      } else {
        headerToSet = {
          headers: {
            ...header,
            'innovel-beta': 'true',
            'innovel-question-beta': 'true'
            // Note: ext-cl-cus header added server-side by Express proxy
          }
        };
      }
    }

    switch (httpMethod) {
      case 'get':
        return axios.get(url, headerToSet);
      case 'post':
        return axios.post(url, inputParams, headerToSet);
      case 'put':
        return axios.put(url, inputParams, headerToSet);
      case 'delete':
        return axios.delete(url, headerToSet);
      default:
        throw new Error('Unsupported http method');
    }
  };
}

export let apiRepo = new ApiRepo();
